import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { AnalysisStatus } from '@/api/domains/analyses/types';
import styles from './StatusFilter.module.css';

interface StatusFilterProps {
  statusFilter: AnalysisStatus | 'all';
  onChange: (value: AnalysisStatus | 'all') => void;
}

export const StatusFilter = ({ statusFilter, onChange }: StatusFilterProps) => (
  <ToggleButtonGroup
    value={statusFilter}
    exclusive
    onChange={(_, val) => {
      if (val !== null) onChange(val);
    }}
    size="small"
    className={styles.filterGroup}
  >
    <ToggleButton value="all">All</ToggleButton>
    <ToggleButton value="PENDING">Pending</ToggleButton>
    <ToggleButton value="PROCESSING">Processing</ToggleButton>
    <ToggleButton value="COMPLETED">Completed</ToggleButton>
    <ToggleButton value="FAILED">Failed</ToggleButton>
  </ToggleButtonGroup>
);
